"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteContext = void 0;
const react_1 = require("react");
exports.SiteContext = react_1.createContext({
    id: null,
});
//# sourceMappingURL=index.js.map